var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.522 2 22 6.47797 22 12C22 17.522 17.522 22 12 22C6.47797 22 2 17.522 2 12C2 6.47797 6.47797 2 12 2ZM14.293 8.29297L12 10.586L9.707 8.29306L8.29302 9.70705L10.586 12L8.29302 14.293L9.707 15.707L12 13.414L14.293 15.707L15.707 14.293L13.414 12L15.707 9.707L14.293 8.29297Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9c3f36bc06bded6165080e24da04a566.svg";
export { ForwardRef as ReactComponent };